import Footer from "@/components/layout/Footer";
import Header from "@/components/layout/Header";
import HeroSection from "@/components/layout/HeroSection";
import HomeGarizim from "@/components/layout/HomeGarizim";
import HomeGarizimSections from "@/components/layout/HomeGarizimSections";

const Index = () => {
  return (
    <div className="min-h-screen bg-white font-sans">
      <Header />
      <main>
        <HomeGarizim />
        <HomeGarizimSections />
        <HeroSection />
      </main>
      <Footer />
    </div>
  );
};

export default Index;
